/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsDocContent
 */
export interface MelcoModelsDocContent {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDocContent
     */
    tags?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDocContent
     */
    content?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDocContent
     */
    type?: string | null;
}

export function MelcoModelsDocContentFromJSON(json: any): MelcoModelsDocContent {
    return MelcoModelsDocContentFromJSONTyped(json, false);
}

export function MelcoModelsDocContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsDocContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function MelcoModelsDocContentToJSON(value?: MelcoModelsDocContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tags': value.tags,
        'content': value.content,
        'type': value.type,
    };
}


